// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    fieldLabel = "fieldLabel",
    isDisabled = "isDisabled",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isDisabled]: boolean;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    currentPackagingItem: state.greif.components.recommendedProductRequestForm.fieldValues["currentPackagingItem"],
    location: getLocation(state),
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CurrentPackagingItemStyles {
    currentPackagingItemTextField?: TextFieldPresentationProps;
}

export const currentPackagingItemStyles: CurrentPackagingItemStyles = {};

const styles = currentPackagingItemStyles;

const CurrentPackagingItem: FC<Props> = ({ fields, location, currentPackagingItem, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [currentPackagingItemErrorMessage, setCurrentPackagingItemErrorMessage] = useState("");

    const currentPackagingLabel = translate("Current Product Item Number");

    const queryString = location.search;
    const { productNumber } = parseQueryString<{ productNumber: string }>(queryString.replace("?", ""));

    useEffect(() => {
        recommendedProductRequestFormContext.validators.currentPackagingItem = validateCurrentPackagingItem;
        if (typeof currentPackagingItem !== "undefined") {
            validateCurrentPackagingItem();
        }
    }, [currentPackagingItem]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.currentPackagingItem = validateCurrentPackagingItem;
    }, [isRequired]);

    useEffect(() => {
        if (productNumber) {
            setFieldValue({ key: "currentPackagingItem", value: productNumber });
        }
    }, [productNumber]);

    const validateCurrentPackagingItem = () => {
        const errorMessage =
            isRequired && !currentPackagingItem ? siteMessage("Field_Required", currentPackagingLabel).toString() : "";
        setCurrentPackagingItemErrorMessage(errorMessage);
        return !errorMessage;
    };

    const currentPackagingItemChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "currentPackagingItem", value: event.target.value });
    };

    return (
        <TextField
            {...styles.currentPackagingItemTextField}
            label={currentPackagingLabel}
            value={currentPackagingItem || ""}
            onChange={currentPackagingItemChangeHandler}
            required={isRequired}
            error={currentPackagingItemErrorMessage}
            disabled={isDisabled}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CurrentPackagingItem),
    definition: {
        displayName: "Current Item Number",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
